import Vue from "vue";
import Router from "vue-router";
const Home = () => import("./views/Home");
const RollCall = () => import("./views/RollCall");
const packageWeigh = () => import("./views/package-weigh.vue");

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/roll-call",
      name: "roll-call",
      component: RollCall
    },
    {
      path: "/package-weigh",
      name: "package-weigh",
      component: packageWeigh
    }
  ]
});
